import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { FaPlus, FaAlignLeft, FaImages, FaTrash } from "react-icons/fa";
import NiceModal from '@ebay/nice-modal-react';
import ConversationTranscriptionModal from "../ConversationTranscriptionModal/ConversationTranscriptionModal";
import ConversationDocumentsModal from "../ConversationDocumentsModal/ConversationDocumentsModal";
import "./FloatingMenu.css";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { useMode } from "../ConversationProfil/ConversationCard/ModeContext/ModeContext";
const FloatingMenu = forwardRef(function FloatingMenu({ conversation, setConversation, audioRef }, ref) {
    const { mode } = useMode();

    const [open, setOpen] = useState(false);

    const [currentMenu, setCurrentMenu] = useState(false);
    const [currentMenuName, setCurrentMenuName] = useState("");
    const menuRef = useRef(null);
    const lastShownRef = useRef(null);
    const onClickViewTranscription = (scrollToStart) => {
        showMenu(ConversationTranscriptionModal, { audioRef, scrollToStart }, "ConversationTranscriptionModal");
    };
    const onClickViewDocuments = () => {
        showMenu(ConversationDocumentsModal, {}, "ConversationDocumentsModal")
    }

    useImperativeHandle(ref, () => ({
        openTranscriptionAt: (start) => onClickViewTranscription(start)
    }));
    const options = [
        { icon: <FaImages />, onClick: () => onClickViewDocuments() },
        { icon: <FaAlignLeft />, onClick: () => onClickViewTranscription() },
        //{ icon: <FaPlus />, onClick: () => alert("Add clicked") },
    ];

    const onOpen = (modal) => {
        setCurrentMenu(modal);
    }
    const buildEnhancedValues = (values) => ({
        ...values,
        onOpen: onOpen,
        conversation: conversation,
        setConversation: setConversation,

        onCloseFromMenu: () => {
            lastShownRef.current = null;
            setCurrentMenu(null);
            setCurrentMenuName("");
        }
    });
    const showMenu = (comp, values, name) => {
        if (currentMenuName == name) return;
        const enhancedValues = buildEnhancedValues(values);
        lastShownRef.current = { comp, values };

        if (currentMenu != null && currentMenu != false) {
            let { onClose } = useModalHelper(currentMenu);
            onClose();
            setTimeout(() => NiceModal.show(comp, enhancedValues), 400);
        }
        else {
            NiceModal.show(comp, enhancedValues)
        }
        setCurrentMenuName(name);
    }

    // FloatingMenu re-renders with a fresh `conversation` prop whenever
    // ConversationProfil updates it (e.g. after adding a criteria from the
    // transcription modal), but NiceModal.show() only snapshots props at
    // open-time - an already-open modal never sees that update on its own.
    // Re-push the latest conversation/setConversation into it so it doesn't
    // display stale data (e.g. a just-added criteria still shown as
    // selectable) until a full page refresh.
    useEffect(() => {
        if (!lastShownRef.current) return;
        const { comp, values } = lastShownRef.current;
        NiceModal.show(comp, buildEnhancedValues(values));
    }, [conversation]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={menuRef} className="fab-wrapper">
            {/* Menu vertical au-dessus du bouton */}
            <div className={`fab-menu ${open ? "open" : "closed"}`}>
                <div className="fab-menu">
                    {options.map((opt, i) => (
                        <button
                            key={i}
                            onClick={() => { opt.onClick(); setOpen(false); }}
                            className="fab-menu-button"
                            style={{ transitionDelay: `${i * 40}ms` }}
                        >
                            {opt.icon}
                        </button>
                    ))}
                </div>
            </div>

            <button onClick={() => setOpen(!open)} className={`fab-main-button ${open ? "open" : ""}`}>
                <FaPlus />
            </button>
        </div>
    );
});

export default FloatingMenu;